<template>
  <login-form
    title="宋凰数字化运营系统" />
</template>

<script>
import LoginForm from '@/components/business/login/login-form.vue'
// import Location from '@/utils/location'
export default {
  name: 'Login',
  components: { LoginForm },
  data() {
    return {
      // type: Location.getCurrentWebName()
      // type: 'ciqa'
    }
  }
  // computed: {
  //   title() {
  //     const map = {
  //       zs: '中质追溯',
  //       cus: '进出口追溯系统',
  //       bj: '北京海关进出境产品质量安全',
  //       zaiq: '浙江省检验检疫科学技术研究院',
  //       ciqa: '北京华检技术服务中心',
  //       gz: '广州进出境产品质量安全'
  //     }
  //     return map[this.type] || '中质追溯'
  //   },
  //   subTitle() {
  //     const map = {
  //       gz: '追溯监管系统',
  //       bj: '追溯监管系统',
  //       zaiq: '重要产品质量追溯系统',
  //       ciqa: '定制产品追溯系统'
  //     }
  //     return map[this.type] || ''
  //   }
  // }
}
</script>
